/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vexed_Slimy_Husky_DialInputs */

const fr_vexed_slimy_husky_dial = /** @type {(inputs: Vexed_Slimy_Husky_DialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, WebP, SVG — recommandé 200×200px`)
};

/**

* @param {Vexed_Slimy_Husky_DialInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vexed_slimy_husky_dial = /** @type {((inputs?: Vexed_Slimy_Husky_DialInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vexed_Slimy_Husky_DialInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vexed_slimy_husky_dial(inputs)
});